import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");

        const response = await axios.get(config.apiUrl + 'state/all?page=' + page + '&resultCount=' + count + '&keyword=' + keyword, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            return {
                status: 200,
                states: response.data.states,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
            
        }        
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

const Add = async (countryId, name) => {
    try {
        const data = new FormData();
        data.append("countryId", countryId);
        data.append("name", name);
        console.log(data);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'state/add', data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 201) {
            return {
                status: 200,
                message: response.data.message,
                state: response.data.state
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };

    }
}

//update state 
const Update = async (id, countryId, name, status) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("countryId", countryId);
        data.append("name", name);
        data.append("status", status);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'state/update', data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                state: response.data.state
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}

//get by id
const GetById = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'state/get-by-id?id=' + id, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            return {
                status: 200,
                state: response.data.state
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}

export { GetAll, Add, Update, GetById };